export const TENANT_SETUP_STEPS = [
    'COMPANY',
    'SALES',
    'PURCHASING',
    'INVENTORY',
    'USERS',
    'COMMUNICATION',
    'DATA_TRANSFER',
    'REVIEW',
];
export const TENANT_SETUP_STATUSES = ['IN_PROGRESS', 'READY', 'COMPLETED'];
export const SETUP_VERIFICATION_KINDS = ['DOCUMENT', 'EMAIL'];
export const SETUP_VERIFICATION_STATUSES = ['PASSED', 'FAILED'];
export const SETUP_DATA_TRANSFER_DECISIONS = ['IMPORT_NOW', 'IMPORT_LATER', 'NO_DATA'];
export const BUSINESS_TERM_SCOPES = ['SALES', 'PURCHASE', 'BOTH'];
export const DOCUMENT_TEXT_PLACEMENTS = ['HEADER', 'FOOTER'];
export const NUMBER_RANGE_RESETS = ['NONE', 'YEARLY', 'MONTHLY'];
export const SETUP_DATA_ENTITY_TYPES = [
    'CUSTOMERS',
    'SUPPLIERS',
    'CONTACTS',
    'ADDRESSES',
    'PRODUCTS',
    'PRICES',
    'INVENTORY',
    'OPEN_ITEMS',
    'HISTORICAL_DOCUMENTS',
];
export const SETUP_SALES_NUMBER_RANGE_KEYS = [
    'QUOTE',
    'ORDER',
    'DELIVERY_NOTE',
    'INVOICE',
];
export const SETUP_PURCHASE_NUMBER_RANGE_KEYS = ['PURCHASE_ORDER', 'GOODS_RECEIPT'];
//# sourceMappingURL=setup.js.map